import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PromoWheel from '../components/PromoWheel';

const PromoWheelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="container-max py-4">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate(-1)}
              className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Roue de Promotions</h1>
              <p className="text-sm text-gray-600">Tentez votre chance et gagnez des réductions exclusives!</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="container-max py-8">
        <PromoWheel />
      </div>
    </div>
  );
};

export default PromoWheelPage;
